import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import { CardContent, CardTitle } from 'components/ui/card';

import { ProjectItem } from '../../types';

interface CardContentSectionProps {
    item: ProjectItem;
    typeLabel: string;
    icon: string;
    iconBgColor: string;
    onStarClick?: (item: ProjectItem) => void;
    isStarred: boolean;
}

export const CardContentSection: React.FC<CardContentSectionProps> = ({
    item,
    typeLabel,
    icon,
    iconBgColor,
    onStarClick,
    isStarred
}) => {
    const handleStarClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onStarClick?.(item);
    };

    return (
        <CardContent className="p-4">
            <div className="flex items-center gap-3">
                {/* Project Icon */}
                <div className="flex-shrink-0">
                    <FontAwesomeIcon
                        style={{
                            boxShadow:
                                'inset 0 0 4px 0 rgba(0, 0, 0, 0.10)'
                        }}
                        icon={icon}
                        className={cn("p-4 rounded-full text-[12px]", iconBgColor)}
                    />
                </div>

                {/* Project Info */}
                <div className="flex-1 min-w-0">
                    <CardTitle className="text-sm font-semibold text-base-mutedForeground truncate overflow-hidden">
                        {item.name}
                    </CardTitle>
                    <p className="text-sm font-normal text-zinc-600">
                        {typeLabel}
                    </p>
                    {item.portalName && (
                        <p className="text-p-xs text-base-mutedForeground mt-1">
                            Portal: {item.portalName}
                        </p>
                    )}
                </div>

                {/* Star Action */}
                {onStarClick && (
                    <div className="flex-shrink-0 ml-auto">
                        <button
                            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
                            onClick={handleStarClick}
                        >
                            <FontAwesomeIcon
                                icon={isStarred ? "fa-solid fa-star" : "fa-regular fa-star"}
                                className={cn(
                                    "w-4 h-4 transition-colors",
                                    isStarred ? "text-yellow-400" : "text-base-input hover:text-gray-600"
                                )}
                            />
                        </button>
                    </div>
                )}
            </div>
        </CardContent>
    );
};

